import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function backChequesInquiry(token, params){
    return Api.post(REQUEST_URLS.FIN_CHECK.FACILITY_INQUIRY,params,{
        headers:{
            'Authorization': 'Bearer ' + token
        }
    })
}
export default backChequesInquiry;